import React, { FC } from 'react';
import { StyledVictimItem } from 'components/VictimItem/style';

export interface VictimItemProps {
  firstName: string;
  lastName: string;
}

const VictimItem: FC<VictimItemProps> = ({ firstName, lastName }) => {
  return <StyledVictimItem>{`${firstName} ${lastName}`}</StyledVictimItem>;
};

export default VictimItem;
